import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'inrShort',
  standalone: true
})
export class InrShortPipe implements PipeTransform {

  transform(value: number | string): string {
    if (!value && value !== 0) return '';

    const num = Number(value);
    
    // Logic for Crores (Cr) - 10,000,000
    if (num >= 10000000) {
      return '₹' + (num / 10000000).toFixed(2).replace(/\.00$/, '') + ' Cr';
    } 
    // Logic for Lacs (Lacs) - 100,000
    else if (num >= 100000) {
      return '₹' + (num / 100000).toFixed(2).replace(/\.00$/, '') + ' Lacs';
    } 
    // Logic for Thousands (K) - 1,000
    else if (num >= 1000) {
      return '₹' + (num / 1000).toFixed(2).replace(/\.00$/, '') + ' K';
    } 
    // For values less than 1000
    else {
      return '₹' + num.toString();
    }
  }
}
